import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    Typography,
    Alert,
    CircularProgress,
} from "@mui/material";
import EngineeringService from "../../../services/Engineering.service";

export default function DeleteScheduleItemDialog({ open, onClose, item, onDeleted }) {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleDelete = async () => {
        if (!item) return;
        setLoading(true);
        setError("");
        try {
            await EngineeringService.deleteScheduleItem(item.id);
            onDeleted();
            onClose();
        } catch {
            setError("Failed to delete the schedule item. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
            <DialogTitle>Delete Schedule Item</DialogTitle>
            <DialogContent>
                {error && (
                    <Alert severity="error" sx={{ mb: 2 }}>
                        {error}
                    </Alert>
                )}
                <Typography>
                    Are you sure you want to delete this schedule item for{" "}
                    <strong>{item?.task_type_detail?.name}</strong>? This
                    action cannot be undone.
                </Typography>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={loading}>
                    Cancel
                </Button>
                <Button
                    variant="contained"
                    color="error"
                    onClick={handleDelete}
                    disabled={loading}
                    startIcon={loading ? <CircularProgress size={16} /> : null}
                >
                    Delete
                </Button>
            </DialogActions>
        </Dialog>
    );
}
